'use strict';

var isPromise = function isPromise(maybePromise) {
  return maybePromise != null && typeof maybePromise.then === 'function';
};

module.exports.isPromise = isPromise;


//////////////////
// WEBPACK FOOTER
// ../node_modules/redux-serial-effects/dist/utils/isPromise.js
// module id = 422
// module chunks = 0